module.exports = __webpack_public_path__ + "img/more-experirence-icon4.8ec4ac46.png";